import './InformationOverlay.css';
export var InformationOverlayTriggerCSS = '_1ept7390-2-0-1';
export var InformationOverlayTriggerIconCSS = '_1ept7394-2-0-1';
export var InformationOverlayTriggerIconHoverCSS = '_1ept7395-2-0-1';
export var InformationOverlayTriggerIconVariantsCSS = {primary:'_1ept7396-2-0-1',success:'_1ept7397-2-0-1',warning:'_1ept7398-2-0-1',critical:'_1ept7399-2-0-1',neutral:'_1ept739a-2-0-1',onAccent:'_1ept739b-2-0-1'};
export var InformationOverlayTriggerTextCSS = '_1ept7391-2-0-1';